import { AlertTriangle, RotateCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';

// Consistent error state for failed data fetches (replaces silent infinite skeletons).
export const ErrorState = ({
  title = 'Erreur de chargement',
  body = 'Impossible de récupérer les données pour le moment.',
  onRetry,
  className = '',
}) => (
  <div className={`flex flex-col items-center justify-center rounded-2xl border border-dashed bg-rose-50/40 px-6 py-12 text-center ${className}`} data-testid="error-state">
    <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-2xl bg-rose-100 text-rose-500">
      <AlertTriangle className="h-6 w-6" />
    </div>
    <p className="font-display text-sm font-semibold text-foreground">{title}</p>
    <p className="mt-1 max-w-sm text-xs text-muted-foreground break-words">{body}</p>
    {onRetry && (
      <Button variant="outline" size="sm" className="mt-4 gap-1.5" onClick={onRetry} data-testid="error-retry">
        <RotateCcw className="h-4 w-4" /> Réessayer
      </Button>
    )}
  </div>
);
